import { Link, useLocation } from "react-router-dom";
import { Home, Grid, Heart, ShoppingCart, Calendar } from "lucide-react";
import { useCart } from "@/context/CartContext";

const items = [
  { to: "/", icon: Home, label: "Home", testid: "mobile-nav-home" },
  { to: "/shop", icon: Grid, label: "Shop", testid: "mobile-nav-shop" },
  { to: "/site-visit", icon: Calendar, label: "Visit", testid: "mobile-nav-visit" },
  { to: "/wishlist", icon: Heart, label: "Wishlist", testid: "mobile-nav-wishlist" },
  { to: "/cart", icon: ShoppingCart, label: "Cart", testid: "mobile-nav-cart" },
];

export default function MobileNav() {
  const { pathname } = useLocation();
  const { count } = useCart();
  return (
    <nav data-testid="mobile-bottom-nav" className="md:hidden fixed bottom-0 left-0 right-0 z-30 bg-white/95 backdrop-blur-xl border-t border-[var(--yp-border)]">
      <div className="grid grid-cols-5">
        {items.map(({ to, icon: Icon, label, testid }) => {
          const active = to === "/" ? pathname === "/" : pathname.startsWith(to);
          return (
            <Link key={to} to={to} data-testid={testid} className={`flex flex-col items-center gap-0.5 py-2 text-[10px] ${active ? "text-[var(--yp-primary)]" : "text-[var(--yp-muted)]"}`}>
              <div className="relative">
                <Icon size={20} />
                {to === "/cart" && count > 0 && (
                  <span className="absolute -top-1 -right-2 bg-[var(--yp-accent)] text-[9px] text-[var(--yp-text)] rounded-full w-4 h-4 grid place-items-center font-semibold">{count}</span>
                )}
              </div>
              <span>{label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
